import { Theme } from 'config';

const styles = (theme: Theme) => ({
  charts: {
    padding: '0 1em !important',

    '& .statistic': {
      width: '100%',
    },
  },
  gridTable: {
    overflowX: 'auto !important',

    '&.space': {
      marginTop: '3rem !important',
    },
  },
  tableHeader: {
    color: `${theme.darkGray} !important`,
    marginLeft: '.5rem !important',
  },
});

export default styles;
